<template>
	<v-app v-cloak id="app">
		<v-app-bar dense app flat color="primary" hide-on-scroll>
			<v-toolbar-title class="secondary--text">COVID-19</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-toolbar-items>
				<v-btn
					color="transparent"
					class="text-none"
					icon
					small
					text
					@click="showChangeLangDialog = true"
				>
					<v-icon color="black">mdi-translate</v-icon>
				</v-btn>

				<v-dialog v-model="showChangeLangDialog" max-width="600">
					<v-card>
						<v-card-title>{{ $t("pickALanguage") }}</v-card-title>
						<v-card-text class="text-center">
							<v-list-item-group v-model="lang" color="primary" mandatory>
								<v-list-item
									v-for="(language, langCode) in $i18n.messages"
									:key="langCode"
									class="px-8"
									:value="langCode"
								>
									<v-list-item-title>{{ language.language }}</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-card-text>
					</v-card>
				</v-dialog>
			</v-toolbar-items>
		</v-app-bar>

		<v-content app>
			<router-view></router-view>
		</v-content>

		<v-overlay v-model="showOverlay" opacity="1" color="primary">
			<v-progress-circular indeterminate></v-progress-circular>
		</v-overlay>

		<v-footer>
			<v-row no-gutters>
				<v-col class="text-center">
					<v-btn
						color="success"
						text
						class="text-none"
						target="_blank"
						href="https://en.wikipedia.org/wiki/Copyleft"
					>
						<v-icon left>mdi-copyright</v-icon>
						{{ $t("footer.copyright") }}
						<v-icon right style="transform: rotate(180deg);">mdi-copyright</v-icon>
					</v-btn>
					<v-btn
						color="success"
						text
						class="text-none"
						target="_blank"
						href="https://gitlab.com/IbrahimBeladi/covid19"
					>
						<v-icon left>mdi-gitlab</v-icon>
						{{ $t("footer.contribute") }}
					</v-btn>
					<v-btn
						color="success"
						text
						class="text-none"
						target="_blank"
						href="https://en.wikipedia.org/wiki/MIT_License"
					>
						<template>{{ $t("footer.license") }}</template>
					</v-btn>
				</v-col>
			</v-row>
		</v-footer>
	</v-app>
</template>

<script>
export default {
	name: "App",
	data() {
		return {
			lang: null,
			showChangeLangDialog: false
		};
	},
	computed: {
		showOverlay() {
			return this.$store.state.loading;
		},
		rtl() {
			return this.$store.state.rtl;
		}
	},
	watch: {
		rtl(newVal) {
			this.$vuetify.rtl = newVal;
		},
		lang(newLang) {
			this.changeLang(newLang);
		}
	},
	mounted() {
		this.lang = this.getLang();
	},
	methods: {
		changeLang(lang) {
			this.$store.dispatch("setLoading", true);
			this.showChangeLangDialog = false;
			setTimeout(() => {
				var rtl = this.$i18n.messages[lang].rtl;
				this.$i18n.locale = lang;
				this.$store.dispatch("changeLang", lang);
				this.$store.dispatch("changeRTL", rtl);
			}, 200);
			setTimeout(() => {
				this.$store.dispatch("setLoading", false);
			}, 400);
		},
		getLang() {
			return this.$store.state.lang;
		}
	}
};
</script>

<style scoped>
[v-cloak] {
	display: none;
}
</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap');

*,
#app *,
#app .title,
#app .display-1,
#app .headline,
#app .body-1 {
    font-family: 'Tajawal', serif !important;
}
</style>